import React from 'react';
import PropTypes from 'prop-types';
import {Text} from "./Text";

export const Member = (props) => {
	return(
		<li className="members__list-item member">
        {
            props.icon &&
			<div className="member__image">{/* Bootstrap columns replaced by flexbox */}
				<img className="" src={props.icon} alt={props.icon} />
			</div> 
        }
			<div className="member__info">
				<div className="member__info-link">
					<Text content={props.header} />
				</div>
				<div className="member__info-description">
					<Text content={props.description} />
				</div>
			</div>
		</li>
	)
};


Member.propTypes = {
	icon: PropTypes.any,
	header: PropTypes.string,
	description: PropTypes.string,
};


// WEBPACK FOOTER //
// src/client/components/common/CMS/elements/Member.js